import Aos from "aos";
import React, { useEffect, useCallback, useRef } from "react";
import emoji from "../../assets/shushing-face1.png";
import Timeline from "./Timeline";
import { useInView } from "react-intersection-observer";

function Roadmap(props) {
  const ref = useRef();
  const [inViewRef1, inView1] = useInView({
    threshold: 1,
  });
  const [inViewRef2, inView2] = useInView({
    threshold: 1,
  });
  const [inViewRef3, inView3] = useInView({
    threshold: 1,
  });
  const [inViewRef4, inView4] = useInView({
    threshold: 1,
  });

  const setRefs = useCallback(
    (node) => {
      if (node) {
        if (node.id === "1") {
          ref.current = node;
          inViewRef1(node);
        }
        if (node.id === "2") {
          ref.current = node;
          inViewRef2(node);
        }
        if (node.id === "3") {
          ref.current = node;
          inViewRef3(node);
        }
        if (node.id === "4") {
          ref.current = node;
          inViewRef4(node);
        }
      }
      // Ref's from useRef needs to have the node assigned to `current`

      // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
    },
    [inViewRef1, inViewRef2, inViewRef3, inViewRef4]
  );
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });

  return (
    <a id="roadmap" href>
      <div className="flex justify-center p-10 md:p-20 2xl:px-[200px]">
        <div className="lg:w-8/12 w-full">
          <div className="w-full text-center px-5 md:ml-5">
            <h1 className="text-white text-center font-bold md:text-start pt-10  mb-10 text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px]">
              Roadmap
            </h1>
            <p className="tracking-tight letter-spacing:-0.05em text-[#747397] mb-10 text-[18px]">
              This roadmap outlines our goals and where we want to take
              HandiVerse.
            </p>
          </div>

          <Timeline
            height={"h-[500px]"}
            number={".01"}
            title={"The Launch "}
            subtitle={"Q2 2022"}
            inViewport={inView1}
            details={
              <p
                id="1"
                ref={setRefs}
                className="text-sm md:text-[18px] leading-snug tracking-tight letter-spacing:-0.05em text-[#747397]"
              >
                11,000 Mint passes distributed via public raffle presale list
                and private sale among community members.
              </p>
            }
          />
          <Timeline
            height={"h-[500px]"}
            number={".02"}
            title={"The Drop "}
            subtitle={"Q2 2022"}
            inViewport={inView2}
            details={
              <>
                <p
                  id="2"
                  ref={setRefs}
                  className="text-sm md:text-[18px] mb-3 leading-snug tracking-tight letter-spacing:-0.05em  text-[#747397]"
                >
                  Mint pass holders claim their Handitars.
                </p>
                <p className="text-sm md:text-[18px] leading-snug font-bold mb-3 tracking-tight letter-spacing:-0.05em  text-[#747397]">
                  1st round of the “Give a hand” campaign begins with amputees
                  receiving their prosthetic arms.
                </p>
                <p className="text-sm md:text-[18px] mb-3 leading-snug tracking-tight letter-spacing:-0.05em  text-[#747397]">
                  Set up a community virtual hangout with the recipients of
                  prosthetic arms.
                </p>
              </>
            }
          />
          <Timeline
            height={"h-[560px]"}
            number={".03"}
            title={"The Spread "}
            subtitle={"Q3 2022"}
            inViewport={inView3}
            details={
              <>
                <p
                  id="3"
                  ref={setRefs}
                  className="text-sm md:text-[18px] leading-snug mb-3 tracking-tight letter-spacing:-0.05em  text-[#747397]"
                >
                  Establish a prosthetic clinic through the Victoria Hand
                  Project to provide local aid in a region TBD.
                </p>
                <p className="text-sm md:text-[18px] mb-3 leading-snug tracking-tight letter-spacing:-0.05em  text-[#747397]">
                  Launch of Handitars super rare 3d avatars for virtual worlds,
                  and AR filters for social media.
                </p>
                <p className="text-sm flex md:text-[18px] mb-3 leading-snug tracking-tight letter-spacing:-0.05em  text-[#747397]">
                  {" "}
                  Launch “secret” HandiVerse merch. 🤫
                </p>
              </>
            }
          />
          <Timeline
            height={"h-[100px]"}
            number={".04"}
            title={"The Next Step "}
            subtitle={"Q4 2022 "}
            inViewport={inView4}
            details={
              <>
                <p
                  id="4"
                  ref={setRefs}
                  className="text-sm md:text-[18px] mb-3 leading-snug tracking-tight letter-spacing:-0.05em  text-[#747397]"
                >
                  After giving people a hand with the Handitars, we will be
                  ready to take a step up with the “Steppers”. We will reveal
                  more details as we go along.
                </p>
                <p className="text-sm md:text-[18px] mb-3 leading-snug tracking-tight letter-spacing:-0.05em  text-[#747397]">
                  Holders of the Handitars get automatically put on the presale
                  list for the “Steppers”.
                </p>
              </>
            }
          />
        </div>
      </div>
    </a>
  );
}

export default Roadmap;
